module.exports = __webpack_public_path__ + "img/slider_13.fd75eb38.jpg";